import Box from '@mui/material/Box'
import Tooltip from '@mui/material/Tooltip'
import React, { useCallback, useMemo } from 'react'

import { useLazyGetWorkOrderStatusHistoryQuery } from 'api/work-order/getWorkOrderStatusHistory'
import { latestSkipReasons } from 'utils/workOrderStatus'

type Props = {
  workOrderId: string
  // What the status tooltip would say anyway; the skip reasons go under it.
  header?: React.ReactNode
  children: React.ReactElement
}

const SkipReasonTooltip: React.FC<Props> = ({ workOrderId, header, children }) => {
  // Fetched on hover, so a board full of skipped stops costs a request only per stop someone points at.
  const [fetchStatusHistory, { currentData, originalArgs }] = useLazyGetWorkOrderStatusHistoryQuery()
  // The lazy query keeps its last fetch's args, so a drawer reused for another stop still holds the old history.
  const statusEvents = originalArgs?.workOrderId === workOrderId ? currentData?.statusEvents : undefined
  const skipReasons = useMemo(() => latestSkipReasons(statusEvents), [statusEvents])
  const handleOpen = useCallback(() => {
    fetchStatusHistory({ workOrderId }, true)
  }, [fetchStatusHistory, workOrderId])

  const hasTitle = Boolean(header) || skipReasons.length > 0
  return (
    <Tooltip
      arrow
      disableInteractive
      title={
        hasTitle ? (
          <>
            {header}
            {skipReasons.map(reason => (
              <Box key={reason}>{reason}</Box>
            ))}
          </>
        ) : (
          ''
        )
      }
      onOpen={handleOpen}
    >
      {children}
    </Tooltip>
  )
}

export default SkipReasonTooltip
